import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import UserList from "./user-list-model";


const SharePostModel = ({ type, show, hide,sharepost }) => {
    const handleShareModalClose = () => {

    };

    return (
        <>
            <Modal show={show} onHide={hide}>
                <Modal.Header closeButton>
                    <Modal.Title>Share Post</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* <UserList type={type} sharepost={show}/> */}
                    <UserList type={type} sharepost={sharepost} hide={hide}/>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={hide}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SharePostModel;
